let EvaEventsTable = [{
  label: "指标类型",
  prop: "normType",
  sortable: 1
},
{
  label: "当前进度",
  prop: "status"
},
{
  label: "考核周期",
  prop: "season"
},
{
  label: "考核主体",
  prop: "subject"
},
{
  label: "考核对象",
  prop: "object"
},
{
  label: "考评方式",
  prop: "evaType"
},
{
  label: "考核开始时间",
  prop: "beginDate"
},
]

let CommonItems = [{
  label: "序号",
  prop: "userId",
  sortable: 1
},
{
  label: "名称",
  prop: "userName",
},
{
  label: "所属科室",
  prop: "departmentName",
},
{
  label: "政治忠诚",
  prop: "c1",
},
{
  label: "政治定力",
  prop: "c2",
},
{
  label: "政治能力",
  prop: "c3",
},
{
  label: "思想建设",
  prop: "c4",
},
{
  label: "组织纪律",
  prop: "c5",
},
{
  label: "道德品质",
  prop: "c6",
},
{
  label: "廉洁自律",
  prop: "c7",
},
{
  label: "工作态度",
  prop: "c8",
},
{
  label: "工作纪律",
  prop: "c9",
},
{
  label: "总共得分",
  prop: "totalScore",
},
]

let tableData2 = []

export {
  EvaEventsTable,
  CommonItems,
  tableData2
}